module.exports = __webpack_public_path__ + "static/media/Anticelulitidni_masazni_smes_oleju_retina.98218397.jpg";